import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import "../styles/styles.css";

const Footer = () => {
  const { lang, tr } = useLang();
  const isEN = lang === "en";

  return (
    <footer className="site-footer">
      <div className="footer-inner">

        <div className="footer-brand">
          <span className="footer-logo">AIVEO</span>
          <p className="footer-tagline">
            {isEN
              ? "AI Cinema Platform · Beta"
              : "Plataforma de Cine IA · Beta"}
          </p>
        </div>

        <div className="footer-cols">
          <div className="footer-col">
            <h4>{isEN ? "Platform" : "Plataforma"}</h4>
            <Link to="/">{tr.nav.home}</Link>
            <Link to="/movies">{tr.nav.movies}</Link>
            <Link to="/books">{tr.nav.books}</Link>
            <Link to="/comics">{tr.nav.comics}</Link>
            <Link to="/creators">{tr.nav.creators}</Link>
          </div>

          <div className="footer-col">
            <h4>{isEN ? "Company" : "Empresa"}</h4>
            <Link to="/about">{isEN ? "About AIVEO" : "Sobre AIVEO"}</Link>
            <a href="mailto:aiveoaicinema@gmail.com">{isEN ? "Contact" : "Contacto"}</a>
          </div>

          <div className="footer-col">
            <h4>{isEN ? "Legal" : "Legal"}</h4>
            <Link to="/terms">{isEN ? "Terms of Use" : "Términos de Uso"}</Link>
            <Link to="/privacy">{isEN ? "Privacy Policy" : "Política de Privacidad"}</Link>
            <Link to="/ai-policy">{isEN ? "AI Content Policy" : "Política de Contenido IA"}</Link>
            <Link to="/dmca">{isEN ? "Copyright / DMCA" : "Copyright / DMCA"}</Link>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} AIVEO ·{" "}
          {isEN
            ? "All content is AI-generated and for entertainment purposes only."
            : "Todo el contenido es generado por IA y solo con fines de entretenimiento."}
        </p>
        <p className="footer-recaptcha">
          {isEN
            ? "Protected by reCAPTCHA — "
            : "Protegido por reCAPTCHA — "}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
            {isEN ? "Privacy" : "Privacidad"}
          </a>{" · "}
          <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">
            {isEN ? "Terms" : "Términos"}
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
